<template>
  <div class="login">
    <div class="box">
      <el-form v-loading="loading">
        <h3 style="text-align: center">请先登录</h3>
        <el-form-item>
          <el-input v-model="username" placeholder="请输入用户名"> </el-input>
        </el-form-item>
        <el-form-item>
          <!--<el-input @keyup.enter="login" v-model="password" type="password" placeholder="请输入用密码" >-->
          <!--</el-input >-->
          <div class="el-input">
            <input
              class="el-input__inner"
              @keyup.enter="login"
              v-model="password"
              type="password"
              placeholder="请输入用密码"
            />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="display: block; width: 100%"
            @click="login"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import api from "../api";
let { login } = api;

export default {
  name: "index",
  data() {
    return {
      username: "",
      password: "",
      loading: false,
    };
  },
  methods: {
    async login() {
      this.loading = true;
      let res = await login({
        username: this.username,
        password: this.password,
      });

      this.loading = false;
      if (res.data.code === 200) {
        // this.$message.success('登陆成功')
        localStorage.setItem("username", res.data.data.username);
        localStorage.setItem("neworkadmintoken", res.data.data.token);
        localStorage.setItem("menuList", JSON.stringify(res.data.data.menus)); // 权限列表
        // this.$emit('updateMenu')
        // this.$router.push('/')
        location.href = "/";
      }
    },
    keydown(e) {},
  },
  mounted() {},
};
</script>
<style scoped>
.login {
}

.box {
  background: #ffffff;
  padding: 20px;
  width: 400px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/views/login/index.vue